<template>
    <div class="mbottom">
        <!-- <img src="@/assets/img/Group 84.png" alt=""> -->
        <div class="mbottom-top">
            <div class="left">
                <div class="name">
                    <img src="@/assets/img/Group 105@2x.png" alt="">
                    <!-- <p>
                        CORANGE
                    </p>
                    <p>
                        青橙数科集团股份有限公司
                    </p> -->
                </div>
                <div class="position">
                    深圳·北京·中山·长沙·成都
                </div>
            </div>
            <span class="center">
                粤ICP备2022095222号-1
            </span>
            <div class="right">
                <span>李先生</span><span>16625163409</span><span>lijiang@corange.com</span>
                <div>
                    <img class="hover" src="@/assets/img/Group 189@2x.png" alt="">
                    <img class="normal" src="@/assets/img/Group 189-2@2x.png" alt="">
                    <img class="tip" src="@/assets/img/code.png" alt="">
                </div>
                <div>
                    <a title="数英网" href="https://www.digitaling.com/company/41663" target="_blank"><img class="normal" src="@/assets/img/Group 185-1@2x.png" alt=""></a>
                    <a title="数英网" href="https://www.digitaling.com/company/41663" target="_blank"><img class="hover" title="数英网" src="@/assets/img/Group 185@2x.png" alt=""></a>
                </div>
            </div>
        </div>
        <!-- <div class="mbottom-bottom">
            <span>粤ICP备2022095222号-1</span>
        </div> -->
    </div>
</template>
<script>
export default {
    data(){
        return {
            
        }
    },
    // props:['userInfo'],
    name:'mbottom',
    created() {
        
    },
    mounted() {
       
    },
    methods:{
     
    }
}
</script>
<style lang="scss" scoped>
    @media screen and (max-width: 1920px){
        .mbottom{
            .mbottom-top {
                width: 75%;
            }
        }
    }
    @media screen and (min-width:1920px) {
        .mbottom{
            .mbottom-top {
                width: 1440px;
            }
        }
    }
    .mbottom {
        width: 100%!important;
        // min-width: 1080px;
        background: #ffffff;
        // img {
        //     width: 100%;
        //     object-fit: none;
        // }
        .mbottom-top {
            margin: 0 auto;
            height: 90px;
            font-size: 12px;
            min-width: 1080px;
            .left {
                .name {
                    img {
                        width: 112px;
                    }
                    margin-top: 24px;
                    float: left;
                    p {
                        &:first-child {
                            font-size: 22px;
                            font-weight: bold;
                        }
                        &:last-child {
                            font-size: 12px;
                        }
                    }
                }
                .position {
                    float: left;
                    font-size: 12px;
                    margin-left: 64px;
                    line-height: 90px;
                }
            }
            .center {
                text-align: center;
                line-height: 90px;
                padding: 0 8px;
                // margin-left: 130px;
                // transform: scale(0.8);
                // display: none;
            }
            .right {
                line-height: 90px;
                font-size: 12px;
                span {
                    margin: 0 12px;
                    // transform: scale(0.8);
                    display: inline-block;
                    &:first-child {
                        margin-left: 0; 
                    }
                }
                div {
                    display: inline-block;
                    margin-left: 16px;
                    position: relative;
                    img {
                        display: inline-block;
                        width: 20px;
                        height: 20px;
                        vertical-align: middle;
                        cursor: pointer;
                        &.tip {
                            position: absolute;
                            left: 0;
                            top: -50px;
                            width: 80px;
                            height: 80px;
                            display: none;
                        }
                        &.hover{
                            display: none;
                        }
                    }
                    &:hover {
                        img {
                            &.tip {
                                display: block;
                            }
                            &.hover {
                                display: inline-block;
                            }
                            &.normal {
                                display: none;
                            }
                        }
                    }
                }
                
            }
        }
        .mbottom-bottom {
            min-width: 1080px;
            margin: 0 auto;
            text-align: center;
            font-size: 16px;
            color: rgba(0, 0, 0, 0.2);
            span{
                &:first-child {
                    margin-right: 40px;
                }
            }
        }
    }
</style>





// WEBPACK FOOTER //
// src/components/base/pc/mBottom.vue